import React, { useCallback, useContext, useEffect, useState } from 'react';
import context from '../../hoc/context/product/context';
import { Question } from '../../hoc/context/product/context-model';
import { QuestionViewComponent } from './components';
import { enrollmentContext } from '../../hoc/context/enrollment/enrollment-context';
import { QuestionConstants } from '../../hoc/constants/questions.constants';
import { FlowRouteProps } from '../flow/flow';
import { EnrollmentLayout } from '../../hoc/components/layout/enrollment-layout';

interface QuestionRouteProps extends FlowRouteProps {
	questionGroup?: string;
	id?: string;
}

export default function WizardComponent({ flow, location, questionGroup, id }: QuestionRouteProps) {
	const ctxt = useContext(context);
	const enrollmentCtxt = useContext(enrollmentContext);
	const [question, setQuestion] = useState<Question>();

	const getQuestions = useCallback(() => {
		const questions =
			enrollmentCtxt.overrideQuestions[questionGroup as string] ||
			ctxt.json.filterQuestions(
				questionGroup as string,
				enrollmentCtxt.input.performer,
				enrollmentCtxt.input.discardedServices,
				enrollmentCtxt.input.questions
			);
		return (questions && questions[+(id as string)]) ||
			questionGroup === QuestionConstants.savingsGroup
			? questions
			: enrollmentCtxt.overrideQuestions[questionGroup as string] ||
					ctxt.json.filterQuestions(
						questionGroup as string,
						enrollmentCtxt.input.performer,
						undefined,
						enrollmentCtxt.input.questions
					);
	}, [
		ctxt.json,
		enrollmentCtxt.input.discardedServices,
		enrollmentCtxt.input.performer,
		enrollmentCtxt.input.questions,
		enrollmentCtxt.overrideQuestions,
		id,
		questionGroup,
	]);

	useEffect(() => {
		if (id) {
			setQuestion(getQuestions()[+id - 1]);
		}
	}, [getQuestions, id, questionGroup]);

	return (
		<EnrollmentLayout
			label= {id ? getQuestions()[+id  - 1]?.label : ''}
			footer={true}
			mlrVersion={ctxt.json.pages.questions.mlrVersion}
			title={question?.header}>
			<div id="wizard-container" className="text-font rounded-3xl">
				{question && (
					<QuestionViewComponent
						question={question}
						next={() => flow.next(location!, { 
							id: id, 
							questionGroup: questionGroup 
						})} 
					/>
				)}
			</div>
		</EnrollmentLayout>
	);
};
